import React from 'react';
import { Paper, TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const WHAT = ['researchers and professionals', 'organizations and institutions', 'research labs and groups',
  'open positions, PhDs, postdocs and jobs'];
const SHORT = ['researchers', 'organizations', 'labs', 'positions'];

// compact: a small field for the page's title row (the Hub's header), not a full-width panel
const SearchPanel = ({ searchValue, onSearchChange, activeTab, compact = false }) => {
  const field = (
      <TextField
        fullWidth
        size={compact ? 'small' : 'medium'}
        placeholder={compact ? `Search ${SHORT[activeTab] || 'organizations'}…`
          : ` Discover, contact and follow ${WHAT[activeTab] || WHAT[1]}...`}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
      />
  );
  if (compact) return field;
  return <Paper sx={{ p: 0, mb: 1 }}>{field}</Paper>;
};

export default SearchPanel;
